import { combineReducers } from 'redux';
import localForage from 'localforage';
import { userApi } from '@ports/internal-services/user/userApi';
import { subscriptionApi } from '@ports/internal-services/subscription/subscriptionApi';
import { userDetailsApi } from '@ports/internal-services/userDetails/userDetailsApi';
import { notificationSettingsApi } from '@ports/internal-services/notificationSettings/notificationSettingsApi';
import { paymentApi } from '@ports/internal-services/payment/paymentApi';
import { userAddressApi } from '@ports/internal-services/userAddress/userAddressApi';
import { utilityConfigurationApi } from '@ports/internal-services/utilityConfiguration/utilityConfigurationApi';
import { assetApi } from '@ports/internal-services/asset/assetApi';
import { folderApi } from '@ports/internal-services/folder/folderApi';
import { commentApi } from '@ports/internal-services/comment/commentApi';
import { diaryApi } from '@ports/internal-services/diary/diaryApi';
import { commentLikesApi } from '@ports/internal-services/commentLikes/commentLikesApi';
import { likesApi } from '@ports/internal-services/likes/likesApi';
import { favoritesApi } from '@ports/internal-services/favorites/favoritesApi';
import { privateApi } from '@ports/internal-services/private/privateApi';
import { photoTagApi } from '@ports/internal-services/photoTag/photoTagApi';
import { authStateSlice } from './authStateSlice';
import { sessionStateSlice } from './sessionStateSlice';
import { subscriptionStateSlice } from './subscriptionStateSlice';
import { userStateSlice } from './userStateSlice';
import { addressStateSlice } from './billingAddressStateSlice';
import { alertSlice } from './AlertStateSlice';
import { manualLoadingStateSlice } from './manualLoadingStateSlice';
import { commonStateSlice } from './commonStateSlice';
import { folderStateSlice } from './folderStateSlice';
import { filterStateSlice } from './filtersStateSlice';

const rootPersistConfig = {
  key: 'root',
  storage: localForage,
  keyPrefix: 'mykinships-persist-'
};

const rootReducer = combineReducers({
  [authStateSlice.name]: authStateSlice.reducer,
  [sessionStateSlice.name]: sessionStateSlice.reducer,
  [subscriptionStateSlice.name]: subscriptionStateSlice.reducer,
  [userStateSlice.name]: userStateSlice.reducer,
  [addressStateSlice.name]: addressStateSlice.reducer,
  [alertSlice.name]: alertSlice.reducer,
  [manualLoadingStateSlice.name]: manualLoadingStateSlice.reducer,
  [commonStateSlice.name]: commonStateSlice.reducer,
  [folderStateSlice.name]: folderStateSlice.reducer,
  [filterStateSlice.name]: filterStateSlice.reducer,
  [userApi.reducerPath]: userApi.reducer,
  [subscriptionApi.reducerPath]: subscriptionApi.reducer,
  [userDetailsApi.reducerPath]: userDetailsApi.reducer,
  [notificationSettingsApi.reducerPath]: notificationSettingsApi.reducer,
  [paymentApi.reducerPath]: paymentApi.reducer,
  [userAddressApi.reducerPath]: userAddressApi.reducer,
  [utilityConfigurationApi.reducerPath]: utilityConfigurationApi.reducer,
  [commentApi.reducerPath]: commentApi.reducer,
  [diaryApi.reducerPath]: diaryApi.reducer,
  [commentLikesApi.reducerPath]: commentLikesApi.reducer,
  [likesApi.reducerPath]: likesApi.reducer,
  [assetApi.reducerPath]: assetApi.reducer,
  [folderApi.reducerPath]: folderApi.reducer,
  [favoritesApi.reducerPath]: favoritesApi.reducer,
  [privateApi.reducerPath]: privateApi.reducer,
  [photoTagApi.reducerPath]: photoTagApi.reducer
});

export { rootPersistConfig, rootReducer };
